module.exports = __webpack_public_path__ + "img/no-preview-aye.9b30c4fd.svg";